import { render } from "./StnDocumentUploadList.vue?vue&type=template&id=06cde604"
import script from "./StnDocumentUploadList.vue?vue&type=script&lang=js"
export * from "./StnDocumentUploadList.vue?vue&type=script&lang=js"

import "./StnDocumentUploadList.vue?vue&type=style&index=0&id=06cde604&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__